import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { XCircle } from 'lucide-react';
export function FailedMethods() {
  const methods = ["Los métodos de 'dejarlo llorar' te rompen el corazón y te dejan demasiado alterada para volver a dormir tú misma.", 'Los blogs de maternidad te dan consejos vagos que no consideran que tienes que usar tu cerebro de manera estratégica 10 horas al día.', 'Has intentado acostarte temprano, pero la adrenalina del estrés te mantiene mirando al techo esperando el próximo grito.', "Confiar solo en la cafeína ha arruinado tu propio ciclo biológico, haciéndote sentir 'cansada pero cableada' (wired but tired)."];
  return <div className="bg-cream-dark text-navy" data-id="element-14">
      <SectionWrapper data-id="element-15">
        <div className="max-w-4xl mx-auto" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-16" data-id="element-17">
            Por qué lo que has intentado{' '}
            <span className="text-red-800 italic" data-id="element-18">no ha funcionado</span>
          </h2>

          <div className="space-y-6" data-id="element-19">
            {methods.map((method, index) => <div key={index} className="flex items-start bg-white p-6 md:p-8 rounded-sm shadow-sm border border-navy/5" data-id="element-20">
                <XCircle className="text-red-800/70 shrink-0 mt-1 mr-6" size={28} data-id="element-21" />
                <p className="text-lg font-sans text-navy/80 leading-relaxed" data-id="element-22">
                  {method}
                </p>
              </div>)}
          </div>
        </div>
      </SectionWrapper>
    </div>;
}